// extracted by mini-css-extract-plugin
export default {"modal_btns_wrapper":"FullNameModal_modal_btns_wrapper__ax0zF"};